<template>
  <div class="part modals create-customer-modal">
    <a-modal
      title="Create New Customer"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="onCreate"
      @cancel="onCancel"
      :centered="true"
    >
      <a-form-model
        :model="customer"
        ref="customer"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        v-bind="formAttrs"
      >
        <!-- Name -->
        <a-form-model-item label="Name" prop="name">
          <a-input-group compact>
            <a-input v-model="customer.name" style="width: 50%" placeholder="Name" required />
            <a-input v-model="customer.last_name" style="width: 50%" placeholder="Last Name" />
          </a-input-group>
        </a-form-model-item>

        <!-- Organization Button -->
        <a-form-model-item label="Organization" v-if="!is_organization">
          <a-button @click="is_organization = true" icon="cluster">Not an individual?</a-button>
        </a-form-model-item>

        <!-- Organization -->
        <a-form-model-item label="Organization" v-if="is_organization">
          <a-input v-model="customer.organization" placeholder="Organization" />
        </a-form-model-item>

        <!-- Gender -->
        <a-form-model-item label="Gender">
          <a-radio-group v-model="customer.gender" :defaultValue="'unknown'">
            <a-radio-button value="unknown"> Unknown </a-radio-button>
            <a-radio-button value="male"> Male </a-radio-button>
            <a-radio-button value="female"> Female </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <!-- Email -->
        <a-form-model-item label="Email">
          <a-input v-model="customer.email" placeholder="Email" />
        </a-form-model-item>

        <!-- Phone -->
        <a-form-model-item label="Phone" prop="phone">
          <a-input-group compact>
            <a-input v-model="customer.phone" style="width: 50%" placeholder="Number" required />
            <a-input v-model="customer.phone_extension" style="width: 50%" placeholder="Extension" />
          </a-input-group>
        </a-form-model-item>

        <!-- Secondary Phone -->
        <a-form-model-item label="Secondary Phone">
          <a-input-group compact>
            <a-input v-model="customer.secondary_phone" style="width: 50%" placeholder="Secondary Phone" />
            <a-input v-model="customer.secondary_phone_extension" style="width: 50%" placeholder="Extension" />
          </a-input-group>
        </a-form-model-item>

        <!-- WeChat -->
        <a-form-model-item label="WeChat">
          <a-input v-model="customer.wechat" placeholder="WeChat" />
        </a-form-model-item>

        <!-- Wechat Added? -->
        <a-form-model-item label="WeChat Added">
          <a-radio-group v-model="customer.wechat_added" :defaultValue="false">
            <a-radio-button :value="true"> Yes </a-radio-button>
            <a-radio-button :value="false"> No </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <!-- Address Search  -->
        <a-form-model-item label="Search Address">
          <PlaceAutocompleteInput
            id="address"
            class="ant-input"
            placeholder="Type to search address"
            @placechanged="onPlaceChanged"
          />
        </a-form-model-item>

        <!-- Address -->
        <a-form-model-item label="Full Address">
          <a-input v-model="customer.raw_address" />
        </a-form-model-item>

        <!-- Location -->
        <a-form-model-item label="Location">
          <a-input v-model="customer.location" />
        </a-form-model-item>

        <!-- Primary Language -->
        <a-form-model-item label="Primary Language">
          <a-select v-model="customer.locale" :default-value="'en-US'">
            <a-select-option :value="'en-US'"> English (U.S) </a-select-option>
            <a-select-option :value="'fr-FR'"> French (France) </a-select-option>
            <a-select-option :value="'zh-CN'"> 中文 (中国大陆) </a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- Notification Methods -->
        <a-form-model-item label="Notification Methods">
          <a-checkbox-group v-model="customer.notification_methods">
            <a-checkbox value="email"> Email </a-checkbox>
            <a-checkbox value="sms"> SMS </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>

        <!-- Source -->
        <a-form-model-item label="Source">
          <a-input-group>
            <a-select v-model="customer.source" default-value="unknown" style="width: 100%">
              <a-select-option v-for="option in options_['GENERAL_SOURCES']" :key="option.key" :value="option.key">
                {{ option.value }}
              </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>

        <!-- Referer -->
        <a-form-model-item label="Referer">
          <a-input v-model="customer.referer" />
        </a-form-model-item>

        <!-- Note -->
        <a-form-model-item label="Note">
          <a-input v-model="customer.note" type="textarea" :rows="4" />
        </a-form-model-item>

        <!-- Active -->
        <a-form-model-item label="Active" prop="active">
          <a-switch v-model="customer.active" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import store from '@/store'
import { PlaceAutocompleteInput } from '@/components/reno/inputs'
const KEY = 'CREATE_CUSTOMER'
export default {
  name: 'create-customer-modal',
  components: {
    PlaceAutocompleteInput,
  },
  data() {
    return {
      formAttrs: {
        // autocomplete: 'off',
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      confirmLoading: false,
      is_organization: false,
      customer: {
        notification_methods: ['email'],
        source: 'Unknown',
        locale: 'en-US',
        raw_address: null,
        location: null,
        active: true,
      },
      rules: {
        name: [
          { required: true, message: 'Please input customer name', trigger: 'blur' },
          { min: 1, max: 50, message: 'Length should be 1 to 50', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: 'Please input customer phone', trigger: 'blur' },
          { min: 10, max: 11, message: 'Length should be 10 to 11', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    visible: {
      get() {
        return this.$store.getters['crm/UI_VISIBLE'](KEY)
      },
      set(visible) {
        this.$store.dispatch('crm/UI_VISIBLE', { key: KEY, visible })
      },
    },
  },
  methods: {
    async onCreate(e) {
      this.$refs.customer.validate(async (valid) => {
        if (valid) {
          const new_customer = await store.dispatch('crm/createCustomer', this.customer)
          if (new_customer && new_customer._id) {
            // 新用户已保存
            this.visible = false
            await store.dispatch('pm/setNewProjectCustomer', new_customer)
            await store.dispatch('pm/open', 'CREATE_PROJECT')
          }
        } else {
          this.$message.error('Oops, The customer creation failed!')
          return false
        }
      })
    },
    onCancel(e) {
      this.visible = false
    },
    onReset() {
      this.$refs.customer.resetFields()
    },
    onPlaceChanged(place) {
      if (place) {
        // console.log(place)
        if (place.formatted_address) {
          this.customer.raw_address = place.formatted_address
        }
        if (place.locality && place.administrative_area_level_1) {
          this.customer.location = `${place.locality},${place.administrative_area_level_1}`
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
